import { connect } from 'react-redux';

import { setOriginPage } from '../../actions/inventories_actions';
import { fetchMarketInfo, reSetMarketing, setCurrentMarketing, fetchMarketProduct } from '../../actions/market_action';

import MarketingPage from '../../components/marketing/marketing';

function mapStateToProps(state) {
  return {
    marketAll:state.market.marketingAll,
    currentProduct: state.products.currentProduct,
    isLoading: state.products.isLoading,
    currentMarket: state.market.currentMarket,
    products: state.market.marketingProductList,
    productList: state.market.marketingProductList,
  };
}

export default connect(mapStateToProps, { fetchMarketInfo,reSetMarketing,fetchMarketProduct, setCurrentMarketing, setOriginPage })(MarketingPage);



// WEBPACK FOOTER //
// ./master/jsx/containers/marketing/marketing.jsx